
export const researchInitialValue = {
  museum_id: null,
  site_url: "",
  // attachment_ids: null,
  translations: {
    en: {
      title: "",
      description: ""
    }
  }
};